import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.24 8.716a4.74 4.74 0 0 0 3.708-2.53l1.923-3.711a.88.88 0 0 1 1.633.625l-.602 2.323a2.736 2.736 0 0 0 2.318 3.403l1.956.238a.938.938 0 0 1-.012 1.863l-3.24.351a4.57 4.57 0 0 0-3.624 2.56l-1.754 3.645a.913.913 0 0 1-1.721-.562l.434-2.344a2.895 2.895 0 0 0-2.493-3.4l-1.944-.24a.937.937 0 0 1 .016-1.861z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }